/**
 * The Daily reminder's schedule (local notifications, native apps only; owner, 2026-10-10). One
 * notification a day at {@link REMINDER_HOUR}, a week ahead, rescheduled whenever the app opens,
 * hides or clears a Daily: so today's is skipped once today's Daily is done, and a player who
 * stops opening the app hears from it for a week at most.
 */

/** Local hour of day the reminder comes (after school and work). */
export const REMINDER_HOUR = 17;
/** Days ahead scheduled at a time. */
export const REMINDER_DAYS = 7;

const LINES = [
  "Today's Daily lawn is ready to mow.",
  'A fresh Daily lawn just grew in.',
  'The Daily lawn is getting shaggy. Time to mow?',
] as const;

export interface Reminder {
  at: Date;
  body: string;
}

/** The reminders to schedule from `now`: today's only if the Daily is not done and it is early. */
export function upcomingReminders(now: Date, doneToday: boolean): Reminder[] {
  const out: Reminder[] = [];
  for (let day = 0; day <= REMINDER_DAYS && out.length < REMINDER_DAYS; day++) {
    const at = new Date(now.getFullYear(), now.getMonth(), now.getDate() + day, REMINDER_HOUR);
    if (day === 0 && (doneToday || at.getTime() <= now.getTime())) continue;
    // A line per calendar day, the same whenever it is scheduled.
    const dayNumber = Math.floor(Date.UTC(at.getFullYear(), at.getMonth(), at.getDate()) / 864e5);
    out.push({ at, body: LINES[dayNumber % LINES.length]! });
  }
  return out;
}
